/**
 * Try to safely convert a string to a RegExp.
 * - if string is null/undefined, return undefined
 * - if string is already a RegExp, just return the RegExp
 * - otherwise, return a new RegExp based on the string
 *
 * It will throw default errors if the string is not a valid regexp
 *
 * @param value
 */
export function toRegex (value?: string | RegExp): RegExp | undefined {
  if (value == null) return
  if (value instanceof RegExp) return value
  return new RegExp(value)
}
